import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSupport',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const supportTicket = defineAsyncComponent(() => import("@/components/theme/support/supportTicket.vue"))
const supportTable = defineAsyncComponent(() => import("@/components/theme/support/supportTable.vue"))
let desc = "List of ticket opend by customers"

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Apps",
      title: "Support Ticket"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card9), {
          colClass: "col-sm-12 ",
          title: "Support Ticket List",
          cardhaderClass: "title-header",
          span: "true",
          spanClass: _unref(desc)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(supportTicket)),
            _createVNode(_unref(supportTable))
          ]),
          _: 1
        }, 8, ["spanClass"])
      ])
    ])
  ], 64))
}
}

})